import React, { useState } from 'react';
import '../styles/Settings.css';
import Button from './Button';
import { checkOnAuthStateChanged } from '../functions';

function FUBConnectInstructions({ companyId }) {
    const [connecting, setConnecting] = useState(false);
    const [error, setError] = useState(null);

    const connectFUB = async () => {
        setConnecting(true);
        setError(null);

        try {
            const user = await checkOnAuthStateChanged();
            if (user.status !== 200) {
                setError("You must be logged in to connect Follow Up Boss.");
                setConnecting(false);
                return;
            }

            const idToken = typeof user.user?.getIdToken === 'function'
                ? await user.user.getIdToken()
                : null;

            if (!idToken) {
                setError("Authentication token not available. Please try again.");
                setConnecting(false);
                return;
            }

            const fubOAuthInitUrl = process.env.REACT_APP_FUB_OAUTH_INIT_URL;
            if (!fubOAuthInitUrl) {
                setError("FUB OAuth is not configured. Please contact support.");
                setConnecting(false);
                return;
            }

            const response = await fetch(fubOAuthInitUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ companyId })
            });

            const result = await response.json().catch(() => ({}));

            if (response.ok && result.status === 200 && result.data?.authorizeUrl) {
                window.location.href = result.data.authorizeUrl;
            } else {
                setError(result?.error || "Failed to initiate Follow Up Boss connection.");
                setConnecting(false);
            }
        } catch (err) {
            console.error("FUB OAuth init error:", err);
            setError("An unexpected error occurred. Please try again.");
            setConnecting(false);
        }
    };

    return (
        <div className="salesforce-connect-instructions">
            <div className="salesforce-connect-instructions-content">
                <h3 className="heading-small-bold colour-primary">
                    Connect Follow Up Boss
                </h3>
                <p className="body-regular colour-secondary salesforce-connect-instructions-text">
                    Click below to connect your Follow Up Boss account with Clozers. You'll be redirected to Follow Up Boss to authorize the connection.
                </p>
                {error && (
                    <p className="body-regular colour-error salesforce-connect-instructions-text">
                        {error}
                    </p>
                )}
                <div className="salesforce-connect-instructions-button">
                    <Button
                        buttonType="primary-button"
                        size="large"
                        text={connecting ? "Connecting..." : "Connect Follow Up Boss"}
                        cta={connectFUB}
                        disabled={connecting}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={connecting}
                    />
                </div>
            </div>
        </div>
    );
}

export default FUBConnectInstructions;
